'use client';

import { Icon } from '@/src/components/ui';
import { USER_ROLES } from '@/src/constants/constants';
import { Card, CardContent } from '@workspace/ui/components/card';
import { cn } from '@workspace/ui/lib/utils';
import { ERole } from 'types/src/types';

type Props = {
  value?: ERole;
  onChange?: (role: ERole) => void;
  isSmall?: boolean;
};

export const RolePicker = ({ value, onChange, isSmall }: Props) => {
  return (
    <div className="w-full">
      <div className={cn("grid grid-cols-2 lg:grid-cols-4 gap-2.5", isSmall && "gap-1")}>
        {USER_ROLES.map(({ id, title, icon }) => {
          const selected = value === id;
          return (
            <Card
              key={id}
              className={cn(
                'cursor-pointer transition-all duration-200 hover:bg-bg-gray border-2 shadow-none p-0',
                selected
                  ? 'bg-black/5 border-blue-primary'
                  : 'border-gray-100 bg-white hover:border-gray-200'
              )}
              onClick={() => onChange?.(id)}
            >
              <CardContent
                className={cn(
                  'flex flex-col items-center text-center ',
                  isSmall
                    ? 'md:p-2 md:py-5 p-2 space-y-1'
                    : 'md:p-6 p-2 md:space-y-3 space-y-1'
                )}
              >
                <div
                  className={cn(
                    'rounded-lg flex items-center justify-center transition-colors md:size-9 size-6',
                    selected ? 'text-black/80' : 'text-black/60'
                  )}
                >
                  <Icon
                    name={icon}
                    className={cn(
                      'md:size-9 size-6',
                      selected ? 'text-black/80' : 'text-black/60'
                    )}
                  />
                </div>

                <h3
                  className={cn(
                    'font-normal transition-colors text-xs',
                    selected ? 'text-black/80' : 'text-black/60',
                    isSmall ? 'md:text-sm' : 'md:text-base'
                  )}
                >
                  {title}
                </h3>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
};
